
import { HotLabEquipmentDto, CreateHotLabEquipmentDto, UpdateHotLabEquipmentDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { hotLabEquipmentService, HotLabEquipmentsFilters } from '@services/hotLabEquipmentService'

const { reducer, actions, thunks } = baseCrudReducer<
  HotLabEquipmentDto,
  CreateHotLabEquipmentDto,
  UpdateHotLabEquipmentDto,
  HotLabEquipmentsFilters
>('hotLabEquipment', hotLabEquipmentService)

export default reducer

export const { setFilters: setHotLabEquipmentFilters } = actions

export const {
  getAll: getHotLabEquipments,
  create: createHotLabEquipment,
  update: updateHotLabEquipment,
  remove: removeHotLabEquipment,
} = thunks
